/**
 * Mappers para convertir entre DTOs y modelos de dominio de User
 */

import { UserDto } from '@infra/dto/user.dto';
import { User } from '@domain/models/user.model';

export class UserMapper {
  /**
   * Convierte un DTO UserDto a modelo de dominio
   */
  static toDomain(dto: UserDto): User {
    return {
      initials: dto.initials || this.getInitials(dto.name),
      name: dto.name || '',
      role: dto.role || '',
      timeAgo: dto.timeAgo || dto.time_ago || '',
      photoUrl: dto.photoUrl || null,
      createdAt: dto.createdAt || dto.created_at 
        ? new Date(dto.createdAt || dto.created_at!) 
        : undefined
    };
  }

  /**
   * Convierte una lista de DTOs a modelos de dominio
   */
  static toDomainList(dtos: UserDto[]): User[] {
    return dtos.map(dto => UserMapper.toDomain(dto));
  }

  /**
   * Convierte un modelo de dominio User a DTO
   */
  static toDto(item: User): UserDto {
    return {
      initials: item.initials,
      name: item.name,
      role: item.role,
      timeAgo: item.timeAgo,
      photoUrl: item.photoUrl,
      createdAt: item.createdAt?.toISOString()
    };
  }

  /**
   * Helper para obtener iniciales de un nombre
   */
  private static getInitials(name: string): string {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
}

